import pages from "../../inc/Pages";
import DashboardIndex from "./dashboard";
import NodesIndex from "./nodes";
import NodeShow from "./nodes/show";
import DevicesIndex from "./devices";
import DevicesShow from "./devices/show";
import DeviceTypesIndex from "./device-types";
import DeviceTypeShow from "./device-types/show";
import ProxiesIndex from "./proxies";
import ProxyShow from "./proxies/show";
import ProxyGroupsIndex from "./proxy-groups";
import ProxyGroupShow from "./proxy-groups/show";
import UsersIndex from "./users";
import UserShow from "./users/show";
import RolesIndex from "./roles";
import RoleShow from "./roles/show";
import ScriptsIndex from "./scripts";
import FilesIndex from "./files";
import FileShow from "./files/show";
import DeviceInstallsIndex from "./device-installs";
import TasksIndex from "./tasks";
import LogsIndex from "./logs";
import MonitoringIndex from "./monitoring";
import BenchmarksIndex from "./benchmarks";
import { BenchmarkShow } from "./benchmarks/show";
import ScreenshotsIndex from "./screenshots";
import { ScreenshotShow } from "./screenshots/show";

// Регистрация страниц панели. Таблицы (index) — только существующие в API разделы
// (см. /API.md): dashboard, nodes, devices, device-types, users, roles, scripts.
// nodes/device-types/users/roles дополнительно имеют карточку (show/create, один
// компонент на оба режима — contextContent.type различает). scripts — только index
// (две вкладки node/device, лейбл правится инлайн в таблице, карточки нет).
// devices — список и карточка: карточка нужна ссылке из ЛК аккаунтов (быстро посмотреть, на
// чём живёт агент и чей аккаунт на нём). Живой экран открывается прямо из списка (см.
// components/window),
// устройства добавляются с карточки ноды ИЛИ сводно на device-installs (деплой по тарифу,
// тот же ApiNode.Deploy) — отдельной карточки устройства нет. device-installs — только
// index, гейт 'admin.nodes' (тот же, что бэкендный admin.nodes.edit на POST .../deploy).
// Права выводятся из префикса: 'admin.nodes' → admin.nodes.index.
pages.add('dashboard', { index: DashboardIndex }, 'admin.dashboard');
pages.add('nodes', { index: NodesIndex, show: NodeShow, create: NodeShow }, 'admin.nodes');
pages.add('devices', { index: DevicesIndex, show: DevicesShow }, 'admin.devices');
pages.add('device-types', { index: DeviceTypesIndex, show: DeviceTypeShow, create: DeviceTypeShow }, 'admin.device-types');
// proxies — справочник прокси + проверка (authorized/admin/proxies); проверка гейтится
// admin.proxies.edit, как на бэкенде.
pages.add('proxies', { index: ProxiesIndex, show: ProxyShow, create: ProxyShow }, 'admin.proxies');
// proxy-groups — группы прокси (authorized/admin/proxy-groups): права — те же admin.proxies.*, что
// и на бэкенде (своей permission-сущности у групп нет).
pages.add('proxy-groups', { index: ProxyGroupsIndex, show: ProxyGroupShow, create: ProxyGroupShow }, 'admin.proxies');
pages.add('users', { index: UsersIndex, show: UserShow, create: UserShow }, 'admin.users');
pages.add('roles', { index: RolesIndex, show: RoleShow, create: RoleShow }, 'admin.roles');
pages.add('scripts', { index: ScriptsIndex }, 'admin.scripts');
// files — библиотека APK: index/show/create есть, удаления в API НЕТ (см. FilesController),
// поэтому карточка идёт с withDestroy={false}.
pages.add('files', { index: FilesIndex, show: FileShow, create: FileShow }, 'admin.files');
pages.add('device-installs', { index: DeviceInstallsIndex }, 'admin.nodes');
pages.add('tasks', { index: TasksIndex }, 'admin.tasks');
pages.add('logs', { index: LogsIndex }, 'admin.logs');
// monitoring гейтится admin.devices (данные — device_performances конкретных устройств) —
// своей permission-сущности у неё нет, тот же приём, что device-installs/admin.nodes.
pages.add('monitoring', { index: MonitoringIndex }, 'admin.devices');
// benchmarks — список бенчмарков устройства (authorized/admin/devices/{id}/benchmarks),
// гейт admin.devices (данные — по устройствам, своей permission-сущности нет, как monitoring).
pages.add('benchmarks', { index: BenchmarksIndex, show: BenchmarkShow }, 'admin.devices');
// screenshots — снимки экранов устройств (authorized/admin/screenshots): крон + кадры задач в
// одном списке. Гейт admin.devices — своей permission-сущности нет, данные по устройствам;
// тот же приём, что у monitoring и benchmarks. Read-only: create/destroy в API нет.
pages.add('screenshots', { index: ScreenshotsIndex, show: ScreenshotShow }, 'admin.devices');

export default pages;
